<template>
  <div>
    <a-modal
      v-model="visible"
      :title="type == 1 ? '门诊发票附件' : '住院发票附件'"
      :width="1200"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <div style="margin-bottom: 20px">
        <a-input
          class="w300"
          placeholder="请输入发票号码/发票备注"
          v-model="number"
        />
        <a-button
          type="primary"
          style="margin-left: 20px"
          @click="handleSearch"
        >
          查询
        </a-button>
      </div>
      <!-- 发票附件 -->
      <invoice-table
        v-model="updateList"
        :file="updateList"
        :disabled="disabled"
        :id="id"
        @refreshList="getList"
      ></invoice-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import InvoiceTable from '@/components/invoice-table/index.vue'
import { getMedicalAttachmentList } from '../api/api'
export default {
  props: ['type', 'id', 'disabled'],
  components: {
    InvoiceTable
  },
  data() {
    return {
      visible: false,
      updateList: [],
      page: 1,
      total: 0,
      size: 10,
      loading: false,
      number: ''
    }
  },
  watch: {
    visible(val) {
      if (val == true) {
        this.number = ''
        this.handleSearch()
      }
    }
  },

  methods: {
    handleCancel() {
      if (!this.disabled) {
        this.$emit('updateDetails')
      }
    },
    handleOk() {
      if (!this.disabled) {
        this.$emit('updateDetails')
      }
    },
    // 查询
    handleSearch() {
      this.page = 1
      this.getList()
    },
    setVisible() {
      this.visible = true
    },
    pageChange(pageber) {
      this.page = pageber
      this.getList()
    },
    getList() {
      this.loading = true
      const params = {
        id: this.id,
        type: this.type,
        page: this.page,
        size: this.size,
        number: this.number
      }
      getMedicalAttachmentList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.updateList = res.data.data
          this.total = res.data.count
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/MedicalFee/components/model-list.vue